import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestList.XeroMatchingV2Section.BillView.ChangeMatchingPopup.ChangeMatchingPopupContext',
    {
        amountError: 'Enter the amount to be allocated for {name}',
    }
);
